module.exports = __webpack_public_path__ + "img/background-video-slider-ford.77fb9c2c.jpg";